export const access: object = {
  access: {
    mainMessage: 'Zugriff verweigert',
    additionalMessage: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen',
    returnMainPage: 'Zur Startseite zurückkehren'
  }
};
